import {useContext} from 'react';

import CustomQueryCacheContext from 'contexts/custom_query_cache_provider';

export default function useCustomQueryCache() {
  const value = useContext(CustomQueryCacheContext);

  return value;
}